<template>
    <v-tab-item :value="WS.value">
        <section class="sub-section">
            <v-container>
                <v-row align="center">
                    <v-col cols="12" lg="6" class="mb-20 mb-lg-0">
                        <div class="img-cap-wrap">
                            <div class="w-100 radius-lg bg-grey pa-16 pt30 py-md-40 py-lg-80">
                                <img src="/images/sub/products/ws/s1-img-en.png" alt="" class="d-block mx-auto">
                            </div>
                            <p class="img-cap font-size-12 font-size-lg-16 color-white font-weight-bold text-center d-flex align-center justify-center">
                                Internet environment
                            </p>
                        </div>
                    </v-col>
                    <v-col cols="12" lg="6">
                        <div class="pl-xl-40">
                            <h3 class="tit--lg font-weight-bold mb-32 mb-lg-58">
                                <!-- What is the Web Shell?  -->
                                {{ settings.product.wsfinder.first }}
                            </h3>
                            <p class="page-text-lg color-point font-weight-700 mb-10 mb-lg-20">
                                The web shell is a web script (asp, php, jsp, cgi) file written so that an attacker can remotely execute commands on a web server.
                            </p>
                            <p class="page-text-lg color-grey-57 mb-10 mb-lg-20">
                                It is a compound word of ‘Web’, which is an abbreviation of a web page, and ‘Shell’, which serves as an interface for issuing and executing commands to the server.
                            </p>
                            <p class="page-text-lg color-grey-57 mb-10 mb-lg-20">
                                It is a program created to execute commands from a web page to the server. It has the form of a web script (asp, php, jsp, cgi, etc.) written to execute commands to the web server remotely.
                            </p>
                            <p class="page-text-lg color-grey-57 mb-10 mb-lg-20">
                                After uploading a web shell to the web server by targeting various vulnerabilities of the web server (server vulnerabilities, web application vulnerabilities, etc.), execute the uploaded web shell through a general web browser (80port), as a result, there are many forms of illegal acts such as leaking and falsifying personal information and distributing malicious codes.
                            </p>
                            <p class="page-text-lg color-grey-57 mb-10 mb-lg-20">
                                It is used as a means of APT (Advanced Persistent Threat) attack.
                            </p>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </section>
        <section class="sub-section bg-grey">
            <v-container>
                <h3 class="tit--lg text-center">
                    <!-- Web Shell management system -->
                    {{ settings.product.wsfinder.second }}
                </h3>
                <div class="s2-box border-light bg-white">
                    <div class="my-30 w-100 px-16">
                        <v-img class="d-block mx-auto mb-6 mb-lg-10" max-width="529" src="/images/sub/products/ws/s2-img-en.png"></v-img>
                        <p class="page-text-lg line-height-1 font-weight-bold text-center">Implementation strategy</p>
                    </div>
                    <v-row no-gutters>
                        <v-col cols="12" lg="4" class="border-top border-right border-color-light">
                            <div class="d-flex bg-point justify-center align-center py-14 border-bottom border-color-light">
                                <v-img class="d-block mr-6 mr-lg-10" max-width="30" src="/images/sub/products/ws/s2-icon1-1.png"></v-img>
                                <p class="page-text-sm font-weight-bold color-white text-center line-height-12">
                                    How to implement <br class="d-none d-lg-block">
                                    Web shell detection
                                </p>
                            </div>
                            <div class="bg-grey py-10 border-bottom border-color-light">
                                <v-img class="mx-auto d-block" max-width="48" src="/images/sub/products/ws/arrow-bottom.png"></v-img>
                            </div>
                            <div class="py-10 border-bottom border-color-light">
                                <p class="page-text-sm font-weight-bold color-point text-center">
                                    Application of web <br class="d-none d-lg-block">
                                    shell detection technology
                                </p>
                            </div>
                            <div class="pa-16 px-md-40 py-md-34">
                                <p class="color-grey-49 bar-txt page-text-sm mb-4 mb-lg-10">
                                    - Application of technology of pattern detection
                                </p>
                                <p class="color-grey-49 bar-txt page-text-sm mb-4 mb-lg-10">
                                    - Application of file hash detection technology
                                </p>
                                <p class="color-grey-49 bar-txt page-text-sm mb-4 mb-lg-10">
                                    - Application of similarity detection technology
                                </p>
                                <p class="color-grey-49 bar-txt page-text-sm">
                                    - Application of Obfuscation Detection Technology
                                </p>
                            </div>
                        </v-col>
                        <v-col cols="12" lg="4" class="border-top border-right border-color-light">
                            <div class="d-flex bg-point justify-center align-center py-14 border-bottom border-color-light">
                                <v-img class="d-block mr-6 mr-lg-10" max-width="30" src="/images/sub/products/ws/s2-icon1-2.png"></v-img>
                                <p class="page-text-sm font-weight-bold color-white text-center line-height-12">
                                    How to implement <br class="d-none d-lg-block">
                                    management S/W
                                </p>
                            </div>
                            <div class="bg-grey py-10 border-bottom border-color-light">
                                <v-img class="mx-auto d-block" max-width="48" src="/images/sub/products/ws/arrow-bottom.png"></v-img>
                            </div>
                            <div class="py-10 border-bottom border-color-light">
                                <p class="page-text-sm font-weight-bold color-point text-center">
                                    Implementation of <br class="d-none d-lg-block">
                                    management system
                                </p>
                            </div>
                            <div class="pa-16 px-md-40 py-md-34">
                                <p class="color-grey-49 bar-txt page-text-sm mb-4 mb-lg-10">
                                    - DashBoard that implements an optimal graphic environment that applies visual intuition
                                </p>
                                <p class="color-grey-49 bar-txt page-text-sm mb-4 mb-lg-10">
                                    - Management system by pattern type, such as malicious scripts, malicious URLs, and hash information
                                </p>
                                <p class="color-grey-49 bar-txt page-text-sm mb-4 mb-lg-10">
                                    - Web shell management by detection pattern, behavior result, and variant web shell type
                                </p>
                                <p class="color-grey-49 bar-txt page-text-sm">
                                    - Agent management through user information and user verification
                                </p>
                                <p class="color-grey-49 bar-txt page-text-sm">
                                    - Provides webshell detection status and pattern statistics information
                                </p>
                            </div>
                        </v-col>
                        <v-col cols="12" lg="4" class="border-top border-color-light">
                            <div class="d-flex bg-point justify-center align-center py-14 border-bottom border-color-light">
                                <v-img class="d-block mr-6 mr-lg-10" max-width="30" src="/images/sub/products/ws/s2-icon1-3.png"></v-img>
                                <p class="page-text-sm font-weight-bold color-white text-center line-height-12">
                                    Other sectors besides <br class="d-none d-lg-block">
                                    analysis environment

                                </p>
                            </div>
                            <div class="bg-grey py-10 border-bottom border-color-light">
                                <v-img class="mx-auto d-block" max-width="48" src="/images/sub/products/ws/arrow-bottom.png"></v-img>
                            </div>
                            <div class="py-10 border-bottom border-color-light">
                                <p class="page-text-sm font-weight-bold color-point text-center">
                                    Applying agent <br class="d-none d-lg-block">
                                    add-on function
                                </p>
                            </div>
                            <div class="pa-16 px-md-40 py-md-34">
                                <p class="color-grey-49 bar-txt page-text-sm mb-4 mb-lg-10">
                                    - Apply malicious URL detection function
                                </p>
                                <p class="color-grey-49 bar-txt page-text-sm mb-4 mb-lg-10">
                                    - Apply real-time detection function
                                </p>
                                <p class="color-grey-49 bar-txt page-text-sm mb-4 mb-lg-10">
                                    - Pattern update
                                </p>
                                <p class="color-grey-49 bar-txt page-text-sm">
                                    - Implement file scan/quarantine function
                                </p>
                            </div>
                            <div class="py-10 border-top border-bottom border-color-light">
                                <p class="page-text-sm font-weight-bold color-point text-center">
                                    Others
                                </p>
                            </div>
                            <div class="pa-16 px-md-40 py-md-34">
                                <p class="color-grey-49 bar-txt page-text-sm mb-4 mb-lg-10">
                                    - Provides a function to classify analysis results of the web shell
                                </p>
                                <p class="color-grey-49 bar-txt page-text-sm">
                                    - Provides a function of distribution of agents and patterns
                                </p>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </v-container>
        </section>
        <section class="sub-section">
            <v-container>
                <h3 class="tit--lg text-center">
                    F1-WSFinder Key Features Summary
                </h3>
                <div class="py-16 py-lg-42 border-bottom border-color-light" style="border-top: 2px solid var(--v-primary-base)">
                    <v-row>
                        <v-col cols="12" lg="2" class="d-flex justify-center">
                            <div class="bg-grey radius-xl d-flex align-center justify-center" style="width: 100px; height: 100px;">
                                <v-img class="mx-auto d-block" max-width="48" src="/images/sub/products/ws/s3-icon1-1.png"></v-img>
                            </div>
                        </v-col>
                        <v-col cols="12" lg="2" class="d-flex d-lg-block justify-center pt-0 pt-lg-18">
                            <h6 class="page-text-lg font-weight-bold text-center text-lg-left">
                                Webshell/<br  class="d-none d-lg-block">Malicious 
                            </h6>
                        </v-col>
                        <v-col cols="12" lg="8">
                            <p class="color-grey-49 bar-txt page-text-sm mb-4 mb-lg-8">
                                - Advance webshell analysis capabilities by applying detection technologies such as similarity detection and obfuscation detection
                            </p>
                            <p class="color-grey-49 bar-txt page-text-sm">
                                - Applying an algorithm that exhibits O(n) performance by adopting the file hash comparison method for the found web shell
                            </p>
                            <p class="color-grey-49 bar-txt page-text-sm">
                                - Detect malicious code injection URLs embedded in web sources
                            </p>
                            <p class="color-grey-49 bar-txt page-text-sm">
                                - Real-time detection without restrictions on the number of files and file size, including exception handling functions
                            </p>
                            <p class="color-grey-49 bar-txt page-text-sm">
                                - Periodic detection, scheduled detection, real-time detection, file extension designation detection, specific folder exception handling detection function
                            </p>
                        </v-col>
                    </v-row>
                </div>
                <div class="py-16 py-lg-42 border-bottom border-color-light">
                    <v-row>
                        <v-col cols="12" lg="2" class="d-flex justify-center">
                            <div class="bg-grey radius-xl d-flex align-center justify-center" style="width: 100px; height: 100px;">
                                <v-img class="mx-auto d-block" max-width="48" src="/images/sub/products/ws/s3-icon1-2.png"></v-img>
                            </div>
                        </v-col>
                        <v-col cols="12" lg="2" class="d-flex d-lg-block justify-center pt-0 pt-lg-18">
                            <h6 class="page-text-lg font-weight-bold text-center text-lg-left">
                                Remote management
                            </h6>
                        </v-col>
                        <v-col cols="12" lg="8">
                            <p class="color-grey-49 bar-txt page-text-sm mb-4 mb-lg-8">
                                - Remote technical support through remote detection inspection history inquiry
                            </p>
                            <p class="color-grey-49 bar-txt page-text-sm mb-4 mb-lg-8">
                                - Quarantine, restore, exception and history management for detected files
                            </p>
                            <p class="color-grey-49 bar-txt page-text-sm mb-4 mb-lg-8">
                                - User, agent, pattern, webshell segmented remote management function
                            </p>
                            <p class="color-grey-49 bar-txt page-text-sm">
                                - System pattern automatic update and agent remote control
                            </p>
                        </v-col>
                    </v-row>
                </div>
                <div class="py-16 py-lg-42 border-bottom border-color-light">
                    <v-row>
                        <v-col cols="12" lg="2" class="d-flex justify-center">
                            <div class="bg-grey radius-xl d-flex align-center justify-center" style="width: 100px; height: 100px;">
                                <v-img class="mx-auto d-block" max-width="48" src="/images/sub/products/ws/s3-icon1-3.png"></v-img>
                            </div>
                        </v-col>
                        <v-col cols="12" lg="2" class="d-flex d-lg-block justify-center pt-0 pt-lg-18">
                            <h6 class="page-text-lg font-weight-bold text-center text-lg-left">
                                Convenient management of UI
                            </h6>
                        </v-col>
                        <v-col cols="12" lg="8">
                            <p class="color-grey-49 bar-txt page-text-sm mb-4 mb-lg-8">
                                - GUI-based user UI application
                            </p>
                            <p class="color-grey-49 bar-txt page-text-sm mb-4 mb-lg-8">
                                - Integrated web UI (supports the same user interface regardless of agent type such as Windows or Linux)
                            </p>
                            <p class="color-grey-49 bar-txt page-text-sm mb-4 mb-lg-8">
                                - Provide separate management functions for pattern/webshell/user/agent
                            </p>
                            <p class="color-grey-49 bar-txt page-text-sm">
                                - Dashboard and Statistical Reports
                            </p>
                        </v-col>
                    </v-row>
                </div>                
            </v-container>
        </section>
    </v-tab-item>
</template>

<script>
import { PRIVATE_SALES_EN_TABS } from "@/assets/variables";
const { WS } = PRIVATE_SALES_EN_TABS;
import api from "@/api"
export default {
    data() {
        return {
            WS,
            filter: {
                code: "en"
            },
            settings: null
        };
    },
    async mounted() {
        await this.init();
    },
    methods: {
        async init() {
            const { settings } = await api.v1.boards.settings.get({
                headers: this.filter
            })
            this.settings = settings[0]
        }
    }
};
</script>

<style>

.img-cap-wrap{
    position: relative;
}

.img-cap{
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 8px 0;
    background-color: #3a69a0;
    width: 120px;
    height: 30px;
}

.s2-box{
    border-radius: 0 0 var(--radius-md) var(--radius-md);
    overflow: hidden;
}

@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    .img-cap{
        width: 200px;
        height: 44px;
    }
}
@media (min-width:1200px){
}


</style>
